export const PERCORSODRAWER = 'PERCORSODRAWER'